import { useEffect } from 'react'
import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import {
  KnowledgeBaseViewProvider,
  useKnowledgeBaseViewContext,
} from 'pages/settings/pages/knowledgeBase/context/knowledgeBaseViewContext'
import { useKnowledgeBaseViewEventDocumentUpload } from 'pages/settings/pages/knowledgeBase/events/useKnowledgeBaseViewDocumentUpload'

const KnowledgeBasePageLayoutContent = () => {
  const store = useKnowledgeBaseViewContext()

  useKnowledgeBaseViewEventDocumentUpload(store)
  useEffect(() => {
    store.loadKnowledgeBaseViewInitialData()
  }, [])

  return <Outlet />
}

export const KnowledgeBasePageLayout = observer(() => {
  return (
    <KnowledgeBaseViewProvider>
      <KnowledgeBasePageLayoutContent />
    </KnowledgeBaseViewProvider>
  )
})
